export const KakeboLogo = ({ size = 36, tile = true, className = "" }) => {
  const svg = (
    <svg viewBox="0 0 100 100" width={size} height={size} className={className} aria-label="Kakebo">
      <circle
        cx="50" cy="50" r="33" fill="none" stroke="#22293A" strokeWidth="13" strokeLinecap="round"
        strokeDasharray="150 57" transform="rotate(-58 50 50)"
      />
      <circle cx="50" cy="50" r="7" fill="#C2492A" />
    </svg>
  );
  if (!tile) return svg;
  return (
    <div
      className={`flex items-center justify-center rounded-[22%] shrink-0 ${className}`}
      style={{ width: size, height: size, background: "#F0EBE1" }}
    >
      <svg viewBox="0 0 100 100" width={size * 0.78} height={size * 0.78} aria-label="Kakebo">
        <circle
          cx="50" cy="50" r="33" fill="none" stroke="#22293A" strokeWidth="13" strokeLinecap="round"
          strokeDasharray="150 57" transform="rotate(-58 50 50)"
        />
        <circle cx="50" cy="50" r="7" fill="#C2492A" />
      </svg>
    </div>
  );
};
